<template>
  <div>
    <div style="padding: 30px; padding-top: 0">
      <div class="main-area">
        <div class="add-customer">
          <el-button
            type="text"
            @click="showSonDialog"
            icon="el-icon-circle-plus-outline"
            >选择已有客户</el-button
          >
        </div>
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-form-item label="客户名称" prop="customerName">
            <el-input
              v-model="form.customerName"
              placeholder="请选择客户"
              disabled="disabled"
            >
            </el-input>
            <el-button slot="append" icon="el-icon-s-operation"
              >已有客户</el-button
            >
          </el-form-item>
          <el-form-item label="项目名称" prop="ProjectTotalName">
            <el-input
              v-model="form.ProjectTotalName"
              placeholder="请填写项目名称"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="项目等级" prop="ProjectLevel">
            <el-select v-model="form.ProjectLevel" placeholder="请选择项目等级">
              <el-option
                v-for="(item, index) in projectLevelDic"
                :key="index"
                :label="item.level"
                :value="item.level"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="销售模式" prop="ContractType">
            <el-select v-model="form.ContractType" placeholder="请选择销售模式">
              <el-option
                v-for="(item, index) in allDictionary['ContractType']"
                :key="index"
                :label="item.dictionaryName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="商务负责人（是否同步为最新的商务负责人）"
            prop="Sales"
          >
           <el-col :span="18">
            <el-select
              v-model="form.Sales"
              filterable
              placeholder="请选择商务负责人"
            >
              <el-option
                v-for="(item, index) in salesOptions"
                :key="index"
                :label="item.userName"
                :value="item.userGUID"
              ></el-option>
            </el-select>
            </el-col>
           <el-col :span="6">
            <el-checkbox v-model="form.NewSales" :true-label="1" :false-label="0" style="margin-left:20px">同步负责人</el-checkbox>
            </el-col>

          </el-form-item>
        </el-form>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <div>
        <el-button @click="resetForm('form')">重 置</el-button>
      </div>

      <div>
        <el-button @click="cancelProjectDialog('form')">取 消</el-button>
        <el-button type="primary" @click="confirmAddProjects('form')"
          >确定新增</el-button
        >
      </div>
    </div>

    <!-- 选择已有客户 -->
    <el-dialog
      append-to-body
      :visible="customerDialog"
      title="选择已有客户"
      width="25%"
      top="10vh"
      @close="customerDialog = false"
    >
      <div>
        <el-form ref="formCustomer" :model="formCustomer" label-position="top">
          <el-form-item label="请输入客户名称" prop="customerName">
            <el-input
              v-model="formCustomer.customerName"
              placeholder="请输入客户名称"
            >
              <el-button slot="append" icon="el-icon-search" @click="Search"
                >搜索客户</el-button
              >
            </el-input>
          </el-form-item>
        </el-form>

        <div v-if="customerDataList.length > 0 && formCustomer.customerName">
          <el-table
            :data="customerDataList"
            :height="240"
            style="width: 100%"
            @row-click="handleSelectionChange"
          >
            <el-table-column width="32">
              <template slot-scope="scope">
                <el-radio v-model="tableRadio" :label="scope.row.id"></el-radio>
              </template>
            </el-table-column>
            <el-table-column
              prop="customerName"
              label="客户名称"
            ></el-table-column>
          </el-table>
        </div>
        <div v-else>
          <div v-if="searchFlag && formCustomer.customerName">暂无搜索结果</div>
          <div v-else></div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog">取 消</el-button>
        <el-button type="primary" @click="customerConfirm" :loading="loadingBtn"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
import { Search, getCommon, ProjectAdd } from "@/api/M_ProjectManagement.js";
import { GetUserByDepartList } from "@/api/index.js";

import { ProjectLevelDic } from "@/utils/common";
export default {
  props: ["closeDialog"],
  data() {
    return {
      allDictionary: {
        ContractType: [] // 全部字典-销售模式
      },
      salesOptions: [], // 所有商务负责人列表
      // 新增项目表单
      form: {
        customerName: "", // 客户名称
        customerId: "", // 客户id
        ProjectTotalName: "", // 项目名称
        ProjectLevel: "", // 项目等级
        ContractType: "", // 销售模式
        Sales: "", // 商务负责人
        NewSales: 0 // 是否同步为最新商务负责人
      },
      projectLevelDic: ProjectLevelDic, // 项目等级select

      formCustomer: {},
      rules: {
        customerName: [
          { required: true, message: "请选择客户", trigger: "blur" }
        ],
        ProjectTotalName: [
          { required: true, message: "请填写项目名称", trigger: "change" }
        ],
        ProjectLevel: [
          { required: true, message: "请选择项目等级", trigger: "change" }
        ],
        ContractType: [
          { required: true, message: "请选择销售模式", trigger: "change" }
        ],
        Sales: [
          { required: true, message: "请选择商务负责人", trigger: "change" }
        ]
      },
      customerDialog: false, // 搜索已有客户弹层
      customerDataList: [], // 搜索结果-已存在的客户列表
      tableRadio: "",
      searchFlag: false, // 是否开启搜索
      customerCurrentSelection: [], // 当前选中的客户信息

      oldCustomer: false, // 是否是老客户
      loadingBtn: false
    };
  },
  activated() {},
  created() {
    this.getMISCommon(); // 获取MIS系统数据字典
  },
  computed: {},
  mounted() {
    this.fnGetUserByDepartList();
  },
  watch: {},
  methods: {
    // 获取商务负责人选项框
    fnGetUserByDepartList() {
      GetUserByDepartList({ departId: "710,2792,281,450" })
        .then((res) => {
          for (var i = 0; i < res.data.length; i++) {
            this.salesOptions.push({
              userName: res.data[i].userName,
              userGUID: res.data[i].userGUID
            });
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    // 获取市场分类，地域select
    async getMISCommon() {
      let res = await getCommon();
      let { dict } = res.data;
      dict.forEach((item) => {
        let obj = {
          ...item
        };
        if (this.allDictionary[item.dictionaryType]) {
          this.allDictionary[item.dictionaryType].push(obj);
        } else {
          this.allDictionary[item.dictionaryType] = [obj];
        }
      });
      this.$forceUpdate();
    },
    // 搜索已有客户
    Search() {
      this.searchFlag = true;
      Search({ CustomerNameLike: this.formCustomer.customerName })
        .then((res) => {
          // console.log(res);
          this.customerDataList = res.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally((res) => {
          this.tableLoading = false;
        });
    },

    handleSelectionChange(currentRow, column, event) {
      if (event.target.className !== "el-radio__inner") {
        // console.log(currentRow);
        this.tableRadio = currentRow.id;
        this.customerCurrentSelection = currentRow;
      }
    },

    // 确定选择该客户
    customerConfirm() {
      this.customerDialog = false;
      this.oldCustomer = true;
      // console.log(this.customerCurrentSelection)
      this.form.customerName = this.customerCurrentSelection.customerName;
      this.form.customerId = this.customerCurrentSelection.id;
      this.$nextTick(() => {
        // this.$refs.formCustomer.resetFields(); // 输入内容重置
        this.customerDataList = []; // 输入内容重置
        // this.$refs.form.validate(); // 验证新增项目表单
      });
    },

    // 取消选择该客户
    cancelDialog() {
      this.customerDialog = false;
      this.$refs.formCustomer.resetFields(); // 输入内容重置
      this.customerDataList = []; // 输入内容重置
    },

    resetForm(formName) {
      this.oldCustomer = false;
      this.$refs[formName].resetFields();
    },

    showSonDialog() {
      this.customerDialog = true;
    },

    cancelProjectDialog(formName) {
      this.$refs[formName].resetFields();
      this.closeDialog();
    },

    confirmAddProjects(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.loadingBtn = true;

          let params = {
            CustomerID: this.form.customerId,
            ProjectTotalName: this.form.ProjectTotalName,
            ProjectLevel: this.form.ProjectLevel,
            ContractType: this.form.ContractType,
            Sales: this.form.Sales,
            NewSales: this.form.NewSales
          };
          let formData = new FormData();
          for (let i in params) {
            formData.append(i, params[i]);
          }
          ProjectAdd(formData)
            .then((res) => {
              this.closeDialog();
              this.$message.success("新增项目成功");
            })
            .catch((err) => {
              console.warn(err);
            })
            .finally(() => {
              this.tableLoading = false;
              this.loadingBtn = true; // 清除按钮loading状态
            });
        } else {
          this.$message.error("请填写完整信息");
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-footer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.el-select {
  width: 100%;
}
.main-area {
  position: relative;
  .add-customer {
    position: absolute;
    right: 0;
  }
}
.el-select-dropdown__item:last-child {
  margin-bottom: 20px;
}
</style>
